import i18next from 'i18next';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/Link';
import TitleLogo from 'components/TitleLogo';

export function PackageTitleTopBorder(props) {
  const {
    additionalClasses,
    logoUrl,
    seeAllText,
    seeAllUrl,
    title,
  } = props;

  if (!title && !logoUrl) {
    return null;
  }

  const h2Classes = classNames(
    'package-title-top-border__title',
  );

  const containerClasses = classNames(
    'package-title-top-border',
    'relative',
    'df',
    'flex-column',
    additionalClasses,
  );

  const isTodayVertical = false;
  const isNotAlternateDisplay = false;

  const link = seeAllUrl
    ? (
      <Link
        className={classNames(
          'package-title-top-border__link',
          {
            'package-title-top-border__link--alt-color': isTodayVertical && isNotAlternateDisplay,
          },
        )}
        to={seeAllUrl}
      >
        {seeAllText || i18next.t('See All')}
      </Link>
    )
    : null;

  return (
    <div className={containerClasses}>
      <div className="package-title-top-border__top-decoration" data-test="topDecoration" />
      <h2 className={h2Classes}>
        <TitleLogo logoUrl={logoUrl} title={title} />
        {link}
      </h2>
    </div>
  );
}

PackageTitleTopBorder.propTypes = {
  additionalClasses: PropTypes.string,
  logoUrl: PropTypes.string,
  seeAllText: PropTypes.string,
  seeAllUrl: PropTypes.string,
  title: PropTypes.string,
};

PackageTitleTopBorder.defaultProps = {
  additionalClasses: '',
  logoUrl: '',
  seeAllText: '',
  seeAllUrl: '',
  title: '',
};
